// File Name: lib/firebase.js
import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  signInWithPopup, 
  GoogleAuthProvider, 
  signOut 
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAuL_4r_1wt48MAfWxJzKnbgdrdykKLxRs",
  authDomain: "yalla-nellab-12650.firebaseapp.com",
  projectId: "yalla-nellab-12650",
  storageBucket: "yalla-nellab-12650.firebasestorage.app",
  messagingSenderId: "342658373407",
  appId: "1:342658373407:web:01ed26ed251d11c0f0422a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);

// Google provider configuration
export const googleProvider = new GoogleAuthProvider();

// Optional: Add custom parameters to Google provider
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// --- Authentication Functions ---

/**
 * Signs up a user with email and password.
 */
export const signUpWithEmail = (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

/**
 * Signs in a user with email and password.
 */
export const signInWithEmail = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

/**
 * Signs in a user with Google Pop-up.
 */
export const signInWithGoogle = () => {
  return signInWithPopup(auth, googleProvider);
};

/**
 * Signs out the current user.
 */
export const logout = () => {
  return signOut(auth);
};

export default app;